import React from "react";
import { useAuth } from "../context/AuthContext";
import ChatPanel from "../components/ChatPanel";

export default function ClientChat() {
  const { user } = useAuth();
  if (!user) return null;

  const pending = user.status === "pending";

  return (
    <div data-testid="client-chat-page" className="space-y-6 fade-up">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-[var(--mp-muted)]">
          Assistenza
        </div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter mt-2">
          Chat con l'agenzia
        </h1>
        <p className="mt-3 text-[var(--mp-muted)] max-w-2xl">
          Scrivici qualsiasi cosa ti serva: un membro di{" "}
          <strong>Marketing Parrucchieri SRL</strong> ti risponde in chat.
          {pending && " Puoi già scriverci anche se il tuo account è in attesa di approvazione."}
        </p>
      </div>

      <ChatPanel
        clientId={user.id}
        selfRole="client"
        selfId={user.id}
        title="Chat con Marketing Parrucchieri SRL"
        height="640px"
      />
    </div>
  );
}
